import { DatePicker } from '@mui/lab';
import { Grid } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import { DateTime } from 'luxon';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';

export interface ReturnComunicationVM {
  date?: DateTime | null;
  note?: string;
}

interface AccordionReturnComunicationFormProps {
  disabled?: boolean;
  values?: ReturnComunicationVM;
  errors?: FormikErrors<ReturnComunicationVM>;
  touched?: FormikTouched<ReturnComunicationVM>;
  onChange: (
    key: keyof ReturnComunicationVM,
    value: ReturnComunicationVM[keyof ReturnComunicationVM]
  ) => void;
}

const AccordionReturnComunicationFormComponent = ({
  values,
  onChange,
  touched,
  errors,
}: AccordionReturnComunicationFormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DatePicker
          label="Data comunicazione *"
          aria-label="Data comunicazione"
          value={values?.date || null}
          onChange={(date) => {
            onChange('date', date || null);
          }}
          renderInput={(params) => (
            <PmiTextField
              id="date"
              {...params}
              error={touched?.date && Boolean(errors?.date)}
              helperText={errors?.date}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          id="note"
          label="Nota comunicazione cittadino *"
          aria-label="Note comunicazione cittadino"
          fullWidth
          multiline
          rows={5}
          inputProps={{
            maxLength: '250',
          }}
          onChange={(event) => {
            onChange('note', event.target.value);
          }}
          value={values?.note || ''}
          error={touched?.note && Boolean(errors?.note)}
          helperText={errors?.note}
        />
      </Grid>
    </Grid>
  );
};

AccordionReturnComunicationFormComponent.displayName =
  'Accordion return comunication form component';

const AccordionReturnComunicationForm = memo(AccordionReturnComunicationFormComponent);

export default AccordionReturnComunicationForm;
